module.exports = __webpack_public_path__ + "img/ico-undo.3daa1753.svg";